export function DebtHeader() {
  return (
    <div className="hidden grid-cols-[repeat(8,minmax(7.5rem,1fr))_5rem] items-start gap-2 text-left text-gray-500 lg:grid">
      <div className="pb-3 font-normal">Lender Name</div>
      <div className="pb-3 font-normal">Original Amount</div>
      <div className="pb-3 font-normal">Funded Date</div>
      <div className="pb-3 font-normal">Maturity Date</div>
      <div className="pb-3 font-normal">Current Balance</div>
      <div className="pb-3 font-normal">Payment Amount</div>
      <div className="pb-3 font-normal">Payment Frequency</div>
      <div className="pb-3 font-normal">Security</div>
      <div className="pb-3 font-normal"></div>
    </div>
  )
}
